import VIEW_MODE from '../constants/viewMode';
import FORM_FACTOR from '../constants/formFactor';
var ViewModeWrapper = /** @class */ (function () {
    function ViewModeWrapper() {
        this.setViewMode = this.setViewMode.bind(this);
        this.isSiteMode = this.isSiteMode.bind(this);
        this.isEditMode = this.isEditMode.bind(this);
        this.isPreviewMode = this.isPreviewMode.bind(this);
        this.isSEOMode = this.isSEOMode.bind(this);
        this.setFormFactor = this.setFormFactor.bind(this);
        this.isFormFactorDesktop = this.isFormFactorDesktop.bind(this);
        this.isFormFactorMobile = this.isFormFactorMobile.bind(this);
        this.isFormFactorTablet = this.isFormFactorTablet.bind(this);
        this.isFormFactorTouch = this.isFormFactorTouch.bind(this);
        this._viewMode = VIEW_MODE.SITE;
        this._formFactor = FORM_FACTOR.DESKTOP;
    }
    ViewModeWrapper.prototype.setViewMode = function (viewMode) {
        this._viewMode = viewMode;
    };
    ViewModeWrapper.prototype.setFormFactor = function (forceVal) {
        this._formFactor = forceVal;
    };
    ViewModeWrapper.prototype.isFormFactorMobile = function () {
        return this._formFactor === FORM_FACTOR.MOBILE;
    };
    ViewModeWrapper.prototype.isFormFactorTablet = function () {
        return this._formFactor === FORM_FACTOR.TABLET;
    };
    ViewModeWrapper.prototype.isFormFactorDesktop = function () {
        return this._formFactor === FORM_FACTOR.DESKTOP;
    };
    ViewModeWrapper.prototype.isFormFactorTouch = function () {
        return this.isMobile() || this.isTablet();
    };
    ViewModeWrapper.prototype.isSiteMode = function () {
        return this._viewMode === VIEW_MODE.SITE;
    };
    ViewModeWrapper.prototype.isEditMode = function () {
        return this._viewMode === VIEW_MODE.EDIT;
    };
    ViewModeWrapper.prototype.isPreviewMode = function () {
        return this._viewMode === VIEW_MODE.PREVIEW;
    };
    ViewModeWrapper.prototype.isSEOMode = function () {
        return this._viewMode === VIEW_MODE.SEO;
    };
    return ViewModeWrapper;
}());
var viewModeWrapper = new ViewModeWrapper();
var isSiteMode = viewModeWrapper.isSiteMode;
var isEditMode = viewModeWrapper.isEditMode;
var isPreviewMode = viewModeWrapper.isPreviewMode;
var isSEOMode = viewModeWrapper.isSEOMode;
var isFormFactorMobile = viewModeWrapper.isFormFactorMobile;
var isFormFactorTablet = viewModeWrapper.isFormFactorTablet;
var isFormFactorDesktop = viewModeWrapper.isFormFactorDesktop;
var isFormFactorTouch = viewModeWrapper.isFormFactorTouch;
export { viewModeWrapper };
export { isSiteMode };
export { isEditMode };
export { isPreviewMode };
export { isSEOMode };
export { isFormFactorMobile };
export { isFormFactorTablet };
export { isFormFactorDesktop };
export { isFormFactorTouch };
//# sourceMappingURL=viewModeWrapper.js.map